import { GeoPoint, MediaImage } from '../../domain/entities/media';

import { RawJson, asRecord, readNumber, readString } from './raw-json';

export function toMediaImage(raw: unknown): MediaImage | null {
  if (typeof raw === 'string') {
    return raw.trim().length > 0 ? { url: raw, alt: '', caption: null } : null;
  }

  const record = asRecord(raw);
  const url = readString(record, 'url', 'src', 'uri', 'href');
  if (url === null) {
    return null;
  }

  return {
    url,
    alt: readString(record, 'alt', 'title') ?? '',
    caption: readString(record, 'caption', 'description'),
  };
}

export function toGeoPoint(source: RawJson): GeoPoint | null {
  const location = asRecord(source['location'] ?? source['geo'] ?? source['coordinates']);
  const latitude =
    readNumber(source, 'locationLat', 'latitude', 'lat') ?? readNumber(location, 'latitude', 'lat');
  const longitude =
    readNumber(source, 'locationLon', 'longitude', 'lon', 'lng') ??
    readNumber(location, 'longitude', 'lon', 'lng');

  if (latitude === null || longitude === null) {
    return null;
  }
  return { latitude, longitude };
}
